<template>
  <v-card class="elevation-12">
    <MailsDataTable
        :loading="loading"
        :mails="mails"
        :total="total"
        :allowed-page="false"
        :allowed-unit-page="false"
        :allow-mass-sign="false"
        :allow-mass-delete="false"
        @update="onUpdate"
    />
  </v-card>
</template>

<script>
import MailsDataTable from '../../../components/mail/MailsDataTable'
import {
  LAYOUT_LOADING_START,
  LAYOUT_LOADING_STOP,
  LAYOUT_TITLE_CHANGED
} from "../../../store/modules/layout/actions";
import MailService from '../../../services/mail.service'
import Moment from 'moment'
import _ from 'underscore'
import Mapper from '../../../mappers'

export default {
  name: "MailListingAllPage",
  components: {
    MailsDataTable
  },
  data() {
    return {
      mails: [],
      total: 0,
      loading: false,
    }
  },
  methods: {
    reloadMails(options, filters) {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      const {sortBy, sortDesc, page, itemsPerPage} = options;
      const {uid, receiver, region, area, start, end, performType, isPerformed, users} = filters;

      const skip = (page - 1) * itemsPerPage;

      MailService.get({
        skip: skip,
        limit: itemsPerPage,
        sort: sortBy.length === 1 ? sortBy[0] : null,
        desc: sortDesc.length === 1 ? sortDesc[0] : null,
        uid: uid,
        receiver: receiver,
        region: region,
        area: area,
        createdStart: start ? Moment(start, 'YYYY-MM-DD') : null,
        createdEnd: end ? Moment(end, 'YYYY-MM-DD') : null,
        users: users ? (users.length > 0 ? users : []) : [],

        performType: performType,
        isPerformed: isPerformed
      })
          .then(response => {
            this.mails = _.map(response.data.Records, mailViewModel => {
              return Mapper.mapMail(mailViewModel)
            })
            this.total = response.data.Total;
          }, () => {

          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    onUpdate(options, filters) {
      this.reloadMails(options, filters)
    }
  },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('mailListingAllPage.pageTitle'))
  }
}
</script>

<style scoped>

</style>